import { render, staticRenderFns } from "./TableItemDetailModal.vue?vue&type=template&id=0533ae73&lang=pug&"
import script from "./TableItemDetailModal.vue?vue&type=script&lang=js&"
export * from "./TableItemDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TableItemDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports